<script>
  import { format } from 'svelte-i18n';
  import { Modal } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Spinner } from '@client/components/spinner';
  import { UserSelect } from '@client/components/user-select';

  import { VirtualBackgroundRoutingService } from '@client/services/virtual-background-routing';

  export let show = false;

  let records = [];
  let showRecords = false;
  let isFetching = false;
  let selectedUser = null;

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onClear();

      show = false;
    }
  };

  const onClear = () => {
    selectedUser = null;
    records = [];
    showRecords = false;
  };

  const parseResponse = (data) => {
    let parsed = {};

    if (data?.background && data?.background?.blockname) {
      parsed.blockname = data.background.blockname;
      parsed.type = $format('label.BACKGROUND');
    }

    return parsed;
  };

  const findMatches = async () => {
    isFetching = true;
    showRecords = true;

    const response = await VirtualBackgroundRoutingService.findByEmail({ email: selectedUser.value });

    if (response.status >= 400) {
      return;
    }

    records = parseResponse(response);

    isFetching = false;
  };
</script>

<Modal bind:isOpen={show} on:close={onClear} size="sm">
  <div class="diagnostics-modal modal--content">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div>
      <div class="title">
        <h1>{$format('label.ROUTING_BACKGROUND_DIAGNOSTICS')}</h1>
        <p>{$format('label.DESCRIPTION.ROUTING_BACKGROUND_DIAGNOSTICS')}</p>
      </div>

      <div class="diagnostics-form">
        <div class="section">
          <div class="section-actions">
            <UserSelect
              placeholder={$format('label.PLACEHOLDER.SEARCH_USERS_DIAGNOSTICS')}
              bind:value={selectedUser}
              on:change={findMatches}
              on:clear={onClear}
            />
          </div>
        </div>

        {#if showRecords}
          <div class="section">
            <div class="section-actions {isFetching ? 'spinner' : 'records'}">
              {#if isFetching}
                <Spinner show inline />
              {:else if Object.values(records).length}
                <div class="record-header"><b>{$format('label.TYPE')}</b></div>
                <div class="record-header">{@html $format('label.BLOCKNAME')}</div>
                <div class="record-item">{records.type}</div>
                <div class="record-item">{records.blockname}</div>
              {/if}
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./diagnostics.scss"></style>
